import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@mui/material";

interface RemovePacksConfirmationProps {
  id: number;
  open: boolean;
  onRemovePacksConfirm: (id: number) => void;
  onCancel: () => void;
  title: string;
  content: string;
}

const RemovePacksConfirmationPopup: React.FC<RemovePacksConfirmationProps> = ({
  id,
  open,
  title,
  content,
  onRemovePacksConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={() => onRemovePacksConfirm(id)} color="secondary">
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemovePacksConfirmationPopup;
